import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bs4grid";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import useAppState from "../../common/StateMachine/useAppState";
import AppContainer from "../AppContainer/AppContainer";
import Button from "../../common/Button/Button";

import "./job-commit.scss";
import { Form, Formik } from "formik";
import TextField from "../../common/formiks/TextField/TextField";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

function JobCommit({ match, history }) {
    const { t } = useTranslation();
    const jobsState = useAppState("jobs");
    const [selectedAmount, setAmount] = useState(jobsState.state.jobDetail.minCollection);

    useEffect(() => {
        jobsState.getJob(match.params.jobId);
        jobsState.getCommitmentByJobId(match.params.jobId).then(res => {
            if (jobsState.state.jobDetail.userCommitment != null &&
                jobsState.state.jobDetail.userCommitment.latestUserCommitment) {
                setAmount(
                    jobsState.state.jobDetail.userCommitment.latestUserCommitment.amount
                );
            } else {
                setAmount(jobsState.state.jobDetail.minCollection);
            }
        });
    }, []);

    function getMaxValue() {
        if (jobsState.state.jobDetail == null || jobsState.state.jobDetail.userCommitment == null) {
            return 100;
        }
        const jobTotal = jobsState.state.jobDetail.amount;
        const totalCommitted = jobsState.state.jobDetail.userCommitment.totalAmountCommitted;

        return jobTotal - totalCommitted;
    }

    function getCommitment() {
        if (jobsState.state.commitment.length > 0) {
            return jobsState.state.commitment[0].amount;
        } else {
            return 0;
        }
    }

    function submitForm(values) {
        const amount = Number(values.amount);
        const currentLat = Cookies.get("plastX_lat");
        const currentLong = Cookies.get("plastX_long");
        if (jobsState.state.commitment.length >= 1) {
            jobsState
                .updateJob(
                    Number(match.params.jobId),
                    jobsState.state.commitment[0].id,
                    amount,
                    currentLat,
                    currentLong
                )
                .then(res => {
                    toast.success(
                        `Commitment updated! You’re now collecting ${amount}kg.`, { autoClose: 5000 });
                    jobsState.getCommitmentByJobId(match.params.jobId);
                    history.push("/jobs/my-jobs");
                })
                .catch(err => {
                    console.error(err);
                    toast.error(err);
                });
        } else {
            jobsState
                .commitJob(Number(match.params.jobId), amount, currentLat, currentLong)
                .then(res => {
                    toast.success(
                        `Welcome to your new job! You’re collecting ${amount}kg.`
                    );
                    jobsState.getCommitmentByJobId(match.params.jobId);
                    history.push("/jobs/my-jobs");
                })
                .catch(err => {
                    console.error(err);
                    toast.error(err);
                });
        }
    }

    return (
        <AppContainer>
            <Container className="mt-16">
                <Row
                    className="pb-32 pt-32"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Col w="auto">
                        <h1>How much will you collect?</h1>
                    </Col>
                </Row>
            </Container>
            <Container fluid className="jobs-list-container pt-16">
                <Row justifyContent="center" alignItems="center">
                    <Col w="auto">
                        <h4>{t("currentCommitment")} {getCommitment()}{t('kg')}</h4>
                    </Col>
                </Row>
                <Row
                    className="jobs-list"
                    justifyContent="center"
                    alignItems="center">
                    <Col w="auto">
                        <Formik validationSchema={
                            Yup.object().shape({
                                amount: Yup.number()
                                    .required()
                                    .min(1, `Amount must be at least 1Kg`)
                                    .max(getMaxValue(), `Amount must be less than ${getMaxValue()}Kg`)
                            })
                        }
                            initialValues={{
                                amount: selectedAmount,
                            }}
                            onSubmit={submitForm}
                            render={({ errors, values, isSubmitting }) =>
                                <Form>
                                    <TextField label={t("minimumCollectionAccepted")}
                                        name="amount"
                                        type="number"
                                        placeholder="Select an Amount" />

                                    <Row className="jobs-list" justifyContent="center" alignItems="center">
                                        <Col w="auto">
                                            <Button
                                                type="submit"
                                                className="mt-32 mb-8"
                                                text="Confirm"
                                            />
                                        </Col>
                                    </Row>
                                </Form>
                            } />
                    </Col>
                </Row>
                <Row className="jobs-list" justifyContent="center" alignItems="center">
                    <Link to={`/jobs/job-details/${match.params.jobId}`}>
                        <Col w="auto">
                            <Button secondary className="mb-32" text="Back to job" />
                        </Col>
                    </Link>
                </Row>
                {jobsState.state.commitment.length >= 1 && (
                    <Row
                        className="jobs-list"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Col w="auto">
                            <Button
                                onClick={() => {
                                    jobsState
                                        .deleteCommitment(jobsState.state.commitment[0].id)
                                        .then(res => {
                                            toast.error("Commitment removed", { autoClose: 5000 });
                                            jobsState.getCommitmentByJobId(match.params.jobId);
                                            history.push("/jobs/my-jobs");
                                        });
                                }}
                                secondary
                                className="mb-32"
                                text="Cancel my job"
                            />
                        </Col>
                    </Row>
                )}
            </Container>
        </AppContainer>
    );
}

export default withRouter(JobCommit);
